import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Onnittelut! Sait {{amount}} käteispalautusta.',
  },
};
